import React from "react";
import ReactApexChart from "react-apexcharts";
import MemberBreakdownList from "./MemberBreakdownList";

const TrendBadge = ({ trend }) => {
  if (!trend) return null;
  const { percent, direction } = trend;
  const cls = `widgetCardTrendBadge widgetCardTrendBadge${
    direction === "up" ? "Up" : direction === "down" ? "Down" : "Neutral"
  }`;
  const arrow = direction === "up" ? "↑" : direction === "down" ? "↓" : "—";
  const sign = direction === "up" ? "+" : direction === "down" ? "-" : "";
  const label = percent != null ? `${sign}${Math.abs(percent).toFixed(0)}% vs prev. period` : "";
  return (
    <div className={cls}>
      <span className="trendArrow">{arrow}</span>
      <span>{label}</span>
    </div>
  );
};

const computeRateMax = values => {
  const peak = values && values.length ? Math.max(...values) : 0;
  if (peak <= 0) return 10;
  let max = Math.ceil(peak * 2);
  if (peak <= 100 && max > 100) max = 100;
  return max;
};

const buildChartOptions = (labels, isSingleDay, metricLabel, isBar = false, yMax = 100) => ({
  chart: {
    type: isBar ? "bar" : "area",
    toolbar: { show: false },
    sparkline: { enabled: false },
    animations: { enabled: false },
    selection: { enabled: false },
    zoom: { enabled: false }
  },
  ...(isBar
    ? { plotOptions: { bar: { borderRadius: 3, columnWidth: "60%" } } }
    : {
        stroke: { curve: "smooth", width: 2 },
        markers: {
          size: isSingleDay ? 5 : 3,
          colors: ["#3953fb"],
          strokeColors: "#fff",
          strokeWidth: 2,
          hover: { size: isSingleDay ? 6 : 4 }
        },
        fill: {
          type: "solid",
          opacity: 0.2
        }
      }),
  colors: ["#3953fb"],
  dataLabels: { enabled: false },
  xaxis: {
    categories: labels,
    labels: { show: isSingleDay, style: { fontSize: "11px" } },
    axisBorder: { show: false },
    axisTicks: { show: false },
    tooltip: { enabled: false }
  },
  yaxis: {
    min: 0,
    max: yMax,
    tickAmount: 4,
    labels: { show: isSingleDay, style: { fontSize: "11px" }, formatter: val => `${val}%` }
  },
  grid: {
    borderColor: "#e8ebee",
    strokeDashArray: 3,
    padding: { left: 0, right: 0, top: 0, bottom: isSingleDay ? 0 : -10 },
    yaxis: { lines: { show: true } },
    xaxis: { lines: { show: false } }
  },
  tooltip: {
    y: {
      title: { formatter: () => (metricLabel ? `${metricLabel}:` : "") },
      formatter: val => `${val?.toFixed(1)}%`
    }
  }
});

const RateWidget = ({ currentRate, trend, chartData = [], dateFilter, bottomStat, metricLabel, visualization, memberBreakdown, breakdownLoading }) => {
  const isKpiOnly = visualization === "KPI";
  const isBar = visualization === "BAR";
  const isSingleDay = chartData.length === 1;
  const labels = chartData.map(d => d.label);
  const values = chartData.map(d => d.value || 0);
  const series = !isKpiOnly && chartData.length > 0 ? [{ name: "Rate", data: values }] : [];
  const options = buildChartOptions(labels, isSingleDay, metricLabel, isBar, computeRateMax(values));

  return (
    <>
      <div className="rateWidgetRateValue">
        {currentRate != null ? currentRate.toFixed(1) : "—"}
        <span className="rateUnit">%</span>
      </div>
      <TrendBadge trend={trend} />
      <MemberBreakdownList rows={memberBreakdown} loading={breakdownLoading} mode="rate" />
      {series.length > 0 && (
        <div className={`rateWidgetChartWrap${isSingleDay ? " singleDayChart" : ""}`}>
          <ReactApexChart
            options={options}
            series={series}
            type={isBar ? "bar" : "area"}
            height={140}
          />
        </div>
      )}
      {bottomStat && (
        <div className="rateWidgetBottomStat">{bottomStat}</div>
      )}
    </>
  );
};

export default RateWidget;
